export default {
  watch: {
    '$route.hash': function (hash) {
      this.tryHighlightingElement(hash)
    }
  },

  mounted() {
    const { hash } = this.$router.currentRoute

    this.tryHighlightingElement(hash)
  },

  methods: {
    tryHighlightingElement(hash) {
      if (hash === '') {
        return
      }

      this.$nextTick(() => {
        const field = this.$el.querySelector(`[data-highlight="${hash.replace('#', '')}"]`)

        if (!field) {
          return
        }

        // Unfortunately we can't rely on $nextTick here, since some
        // components require multiple ticks/async actions to fully render.
        setTimeout(() => {
          field.scrollIntoView({
            block: 'center'
          })
          field.classList.add('flash-highlighted-field')

          setTimeout(() => {
            field.classList.remove('flash-highlighted-field')
          }, 3750) // 3750 = animation-duration * animation-iteration-count in cars/Edit.vue
        }, 1000)
      })
    }
  }
}
